import { render, staticRenderFns } from "./ModuleProductDetailSpecification.vue?vue&type=template&id=e4d8a422&scoped=true&lang=html"
import script from "./ModuleProductDetailSpecification.vue?vue&type=script&lang=js"
export * from "./ModuleProductDetailSpecification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d8a422",
  null
  
)

export default component.exports